import { PERMISSION } from '@/constants/permission.constant';

const gatepassList = () => import('@/views/gatepass/GatepassList.vue');
const createGatepass = () => import('@/views/gatepass/forms/CreateGatepass.vue');
const editGatePass = () => import('@/views/gatepass/forms/EditGatepass.vue');

export const gatepassRoute = [
  {
    path: '/gatepass',
    name: 'gatepass-list',
    component: gatepassList,
    meta: { requiresAuth: false, permissions: [PERMISSION.GATEPASS_READ] },
  },

  {
    path: '/gatepass/create',
    name: 'gatepass-create',
    component: createGatepass,
    meta: { requiresAuth: false, permissions: [PERMISSION.GATEPASS_CREATE] },
  },

  {
    path: '/gatepass/edit',
    name: 'gatepass-edit',
    component: editGatePass,
    meta: { requiresAuth: false, permissions: [PERMISSION.GATEPASS_UPDATE] },
  },
];
